import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';

export const About: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About Your Casinos',
    description: 'Learn about Your Casinos - independent UK casino reviews and comparisons.',
    url: 'https://yourscasinos.com/about'
  };

  return (
    <>
      <SEO
        title="About Us | Independent UK Casino Reviews | Your Casinos"
        description="Your Casinos provides independent, transparent reviews of UK-licensed casinos. Compare bonuses, payout speeds, and find the best deals."
        canonical="/about"
        jsonLd={jsonLd}
      />

      <div className="min-h-screen bg-black py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
            About Your Casinos
          </h1>

          <div className="space-y-8 text-gray-300 leading-relaxed">
            <section className="glass-card p-6">
              <h2 className="text-2xl font-bold text-primary-green mb-4">Our Mission</h2>
              <p>
                Your Casinos exists to cut through the marketing noise and give UK players the real numbers. 
                We test bonuses, verify payout speeds, check licenses, and break down wagering requirements 
                so you can make informed decisions. No fluff, just facts.
              </p>
            </section>

            <section className="glass-card p-6">
              <h2 className="text-2xl font-bold text-primary-green mb-4">What We Do</h2>
              <p className="mb-4">
                Every casino we review goes through the same rigorous process:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Verify UK Gambling Commission licensing status</li>
                <li>Test bonus terms and calculate real wagering requirements</li>
                <li>Check payout processing times across different payment methods</li>
                <li>Evaluate game variety and mobile experience</li>
                <li>Assess customer support responsiveness</li>
                <li>Review responsible gambling tools and policies</li>
              </ul>
            </section>

            <section className="glass-card p-6">
              <h2 className="text-2xl font-bold text-primary-green mb-4">Our Standards</h2>
              <p className="mb-4">
                We only review casinos that meet these essential criteria:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Valid UK Gambling Commission license</li>
                <li>SSL encryption and secure payment processing</li>
                <li>Clear terms and conditions</li>
                <li>Responsible gambling tools available</li>
                <li>Transparent bonus and withdrawal policies</li>
              </ul>
            </section>

            <section className="glass-card p-6">
              <h2 className="text-2xl font-bold text-primary-green mb-4">Independence</h2>
              <p>
                We maintain editorial independence. While we may receive compensation when you click 
                through to casino sites, this never influences our ratings or reviews. Our scores are 
                based on objective testing and player-focused criteria. If a casino doesn't measure up, 
                we'll tell you why.
              </p>
            </section>

            <section className="glass-card p-6">
              <h2 className="text-2xl font-bold text-primary-green mb-4">Responsible Gambling</h2>
              <p className="mb-4">
                Gambling should be entertainment, not a way to make money. We promote responsible 
                gambling and provide links to support organizations. If you need help, reach out to:
              </p>
              <ul className="space-y-2">
                <li>
                  <a href="https://www.gambleaware.org" target="_blank" rel="noreferrer noopener" className="text-primary-green hover:underline">
                    GambleAware
                  </a>
                </li>
                <li>
                  <a href="https://www.gamcare.org.uk" target="_blank" rel="noreferrer noopener" className="text-primary-green hover:underline">
                    GamCare
                  </a>
                </li>
                <li>
                  <a href="https://gamblingtherapy.org" target="_blank" rel="noreferrer noopener" className="text-primary-green hover:underline">
                    Gambling Therapy
                  </a>
                </li>
              </ul>
            </section>

            <div className="text-center pt-8">
              <Link to="/compare" className="btn-primary">
                Compare Casino Offers
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

